<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-06-17 18:04:34
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\CompanyManagement\Payslip\Payslip.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 14:44:08
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_admin_Payslip_list_title')"
    pad="0"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
  >
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(filter);
        "
        @update="
          (prop, value, selected) => {
            if (prop == 'department') curDept = value; //触发岗位更新下拉
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(filter);
            }
          }
        "
      />
    </template>
    <template v-slot:nav-actions>
      <v-btn
        icon
        v-if="hasBtn('import-admin-pay-slip')"
        class="white--text primary mr-2"
        @click="
          files = [];
          selectWillStaff = null;
          selected = [];
          showUpload = true;
        "
      >
        <svg-icon size="24" fill="white" iconClass="upload" />
      </v-btn>
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <v-card class="transparent d-flex flex-row rounded-lg" elevation="0">
        <!-- left -->
        <v-card
          class="fill-height white rounded-lg pa-0"
          elevation="0"
          width="280"
          :style="{
            minHeight: $vuetify.breakpoint.height - 238 + 42 - 48 + 'px',
          }"
        >
          <!-- choose -->
          <noContent v-if="show_Staff.length == 0 && !staff_Loading" />
          <v-sheet
            v-if="staff_Loading"
            :style="{
              minHeight: $vuetify.breakpoint.height - 238 + 42 - 48 + 'px',
            }"
            class="text-center d-flex align-center justify-center"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              size="30"
              width="2"
            ></v-progress-circular>
          </v-sheet>
          <v-list
            dense
            v-if="!staff_Loading"
            :style="{
              maxHeight: $vuetify.breakpoint.height - 238 + 42 - 48 + 'px',
            }"
            class="scroll_content_y"
          >
            <v-list-item-group v-model="selectOneStaff" color="primary">
              <v-list-item
                v-for="(staff, index) in show_Staff"
                :key="`staff---${index}`"
                dense
                two-line
                :value="staff.staff_id"
                class="pa-0 px-2 ma-0"
              >
                <v-list-item-avatar size="36" class="pa-0 ma-0 mr-2">
                  <StaffAvatar
                    size="36"
                    :src="staff.staff_avatar"
                    :staff_name="staff.preferred_name"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">
                    {{ $getCommonLangValue(staff.preferred_name) }}
                    <span class="text--secondary text-caption-xs">{{
                      staff.staff_code
                    }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-body-2">
                    {{ $getCommonLangValue(staff.job_post_name) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
        <!-- left -->
        <v-card
          class="flex-grow-1 ml-3 rounded-lg"
          :class="draging ? 'mrc-border-dashed' : ''"
          elevation="0"
          @dragover="fileDragover"
          @drop="fileDrop"
        >
          <Tabler
            :headers="headers"
            :items="desserts"
            :showSelect="showSelect"
            :defaultSelect="selected"
            @select="onSelect"
            :height="$vuetify.breakpoint.height - 275 - 48"
            :totalCount="totalCount"
            @change="
              (page, perpage, callback) => {
                getList(selectOneStaff, page, perpage, callback);
              }
            "
          >
            <template
              v-slot:header.filename="{ header }"
              v-if="selected.length"
            >
              <v-sheet
                class="transparent d-flex flex-row align-center"
                height="25"
              >
                {{ selected.length
                }}{{ $t("label_table_list_selected_numLabel") }}
                <v-sheet class="grey fill-height mx-1" width="1"></v-sheet>
                <v-btn
                  text
                  color="primary"
                  small
                  class="text-capitalize px-0"
                  :ripple="false"
                  @click="toDownLoad(selected)"
                >
                  <span class="material-icons-round"> save_alt </span
                  >{{ $t("label_essweb_table_list_selected_downloadBtnLabel") }}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  small
                  class="text-capitalize px-0 ml-2"
                  :ripple="false"
                  @click="
                    $confirmDo(
                      $t('label_essweb_admin_Payslip_list_title')
                    ).then((res) => {
                      res ? toDelete(selected) : null;
                    })
                  "
                >
                  <span class="material-icons-round"> delete </span
                  >{{ $t("label_essweb_list_components_tools_delBtnLabel") }}
                </v-btn>
              </v-sheet>
            </template>
            <template v-slot:item.filename="{ item }">
              <v-sheet
                class="
                  d-inline-block
                  text-truncate
                  d-flex
                  align-center
                  transparent
                "
              >
                <svg-icon
                  size="24"
                  fill="#0f46c1"
                  :iconClass="
                    item.doc_type == 'jpg'
                      ? 'filetype-jpg'
                      : item.doc_type == 'csv'
                      ? 'filetype-csv'
                      : item.doc_type == 'doc'
                      ? 'filetype-doc'
                      : item.doc_type == 'gif'
                      ? 'filetype-gif'
                      : item.doc_type == 'png'
                      ? 'filetype-png'
                      : item.doc_type == 'xls'
                      ? 'filetype-xls'
                      : item.doc_type == 'docx'
                      ? 'filetype-doc'
                      : item.doc_type == 'xlsx'
                      ? 'filetype-xls'
                      : item.doc_type == 'pdf'
                      ? 'filetype-pdf'
                      : item.doc_type == 'ppt'
                      ? 'filetype-ppt'
                      : item.doc_type == 'jpeg'
                      ? 'filetype-jpg'
                      : 'filetype-file'
                  "
                />
                <div
                  class="text--primary table-title pa-1"
                  :title="$getCommonLangValue(item.doc_title)"
                >
                  {{ $getCommonLangValue(item.doc_title) }}
                </div>
              </v-sheet>
            </template>
            <template v-slot:item.date="{ item }">
              <div class="text--primary table-title">
                {{ $getDateTime(item.release_utc_datetime, "YYYY/MM/DD") }}
              </div>
            </template>
            <template v-slot:item.upload_time="{ item }">
              <div class="text--primary table-title">
                {{ $getDateTime(item.upload_utc_datetime, "YYYY/MM/DD HH:mm") }}
              </div>
            </template>
            <template v-slot:item.size="{ item }">
              <div class="text--primary table-title">
                {{ $byteconvert(item.doc_size) }}
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <tableListTools
                :uuid="item.uuid"
                :delBtn="hasBtn('delete-admin-pay-slip')"
                :viewBtn="hasBtn('download-admin-pay-slip')"
                :editBtn="hasBtn('edit-admin-pay-slip')"
                :title="$t('label_essweb_admin_Payslip_list_title')"
                @delete="toDelete"
                viewText="label_essweb_table_list_selected_payslipDownloadLabel"
                @edit="toEdit(item)"
                @view="toDownLoad"
              />
            </template>
          </Tabler>
        </v-card>
      </v-card>
    </template>
    <!-- content -->
    <!-- tools -->
    <template v-slot:tools-main>
      <uploadFile
        :show="showUpload"
        @close="showUpload = false"
        :staff="selectWillStaff"
        :files="files"
        @submit="onSubmit"
      />
      <editFiles
        :propertyData="propertyData"
        :show="showEdit"
        @close="showEdit = false"
        @submit="onEdit"
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import uploadFile from "@/Page/EssAdmin/CompanyManagement/Payslip/components/uploadFile";
import editFiles from "@/Page/EssAdmin/CompanyManagement/Payslip/components/editFiles";
var FileSaver = require("file-saver");
import JSZip from "jszip";
import dayjs from "dayjs";
export default {
  name: "Payslip",
  components: { uploadFile, editFiles },
  computed: {
    ...mapGetters(["defaultLang"]),
  },
  data() {
    return {
      draging: false,
      propertyData: null,
      files: [],
      allStaff: [],
      staff_Loading: false,
      selected: [],
      show_Staff: [],
      selectOneStaff: null,
      selectWillStaff: null,
      showEdit: false,
      showUpload: false,
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_Payslip_list_fileNameLabel",
          sortable: false,
          align: "start",
          value: "filename",
        },
        {
          text: "label_essweb_Payslip_list_dateLabel",
          align: "start",
          value: "date",
          sortable: true,
          sort: (prop, desc, calback) => {
            return this.$sortList(
              this.desserts,
              "release_utc_datetime",
              desc ? true : false,
              "datetime"
            ).then((res) => {
              calback(desc);
              this.desserts = res;
            });
          },
        },
        {
          text: "label_essweb_Payslip_list_uploadTimeLabel",
          align: "start",
          value: "upload_time",
          sortable: true,
          sort: (prop, desc, calback) => {
            return this.$sortList(
              this.desserts,
              "upload_utc_datetime",
              desc ? true : false,
              "datetime"
            ).then((res) => {
              calback(desc);
              this.desserts = res;
            });
          },
        },
        {
          text: "label_essweb_Payslip_list_sizeLabel",
          align: "start",
          value: "size",
          sortable: true,
          sort: (prop, desc, calback) => {
            return this.$sortList(
              this.desserts,
              "doc_size",
              desc ? true : false,
              "number"
            ).then((res) => {
              calback(desc);
              this.desserts = res;
            });
          },
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      showSelect: true,
      desserts: [],
      filterPageData: null,
      curDept: [],
      filterObjects: [
        {
          type: "select",
          sequence: 0,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "staff",
          avatar: true,
          twoLine: true,
          multiple: true,
          label: "label_essweb_attendanceRecord_list_staffLabel",
          value: [],
          selected: [],
          data: {
            api: "",
            url_type: "all_staff",
            args: {},
            table: "e",
            immediate: false,
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "org_level_name",
          name: "department",
          multiple: true,
          label: "label_essweb_UM_filters_departmentLabel",
          value: [],

          selected: [],
          data: {
            api: "/dept/get-tree/",
            url_type: "tree",
            args: null,
            table: "mrbase_sys_org_levels",
            type: "",
            modelKey: "org_level_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          showKey: "job_post_name",
          name: "job",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobLabel",
          value: [],
          selected: [],
          data: {
            api: "/job-post/get-list/",
            url_type: "primary",
            args: { dept_uuid: "" },
            table: "mrbase_sys_job_posts",
            type: "",
            modelKey: "job_post_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
    };
  },
  watch: {
    selectOneStaff(val) {
      if (val)
        this.getList(val, 1, this.$tableSetting.perPageSize, () => {
          this.$store.dispatch("resetTable", new Date().getTime());
        });
      else {
        this.desserts = [];
      }
    },
    curDept(val) {
      //监听部门变化
      this.$fliterValue(this.filterObjects, "job", []);
      if (!val || val.length == 0) {
        this.filterObjects[2]["disabled"] = true;
      }
      if (val) {
        let arr = [];
        if (val.length) {
          this.filterObjects[2]["disabled"] = false;
          val.map((e) => {
            if (e && e.uuid) arr.push(e.uuid);
          });
          this.filterObjects[2]["data"]["args"]["dept_uuid"] = arr.join(",");
        } else {
          return;
        }
      }
    },
  },
  mounted() {
    this.getBtnPermissionList();
    this.getStaff();
  },
  methods: {
    getStaff(data) {
      this.staff_Loading = true;
      this.$getStaffList(Object.assign({}, data ? data : {})).then((res) => {
        this.allStaff = res;
        this.show_Staff = res;
        this.staff_Loading = false;
      });
    },
    toFilter(callback) {
      const that = this;
      this.desserts = [];
      this.selectOneStaff = null;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "staff")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "job")
          data["job_post_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "department") {
          let arr = [];
          if (item.value.length) {
            item.value.map((e) => {
              e && e.uuid ? arr.push(e.uuid) : null;
            });
          }
          data["dept_uuid"] = arr.join(",");
        }
      });
      this.getStaff(data);
    },
    onEdit(obj) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "x",
        url: "/pay-slip/updates/",
        data: {
          uuid: obj.uuid,
          doc_title: obj.doc_title,
          release_utc_datetime: this.$getTimeValue(obj.release_utc_datetime),
        },
      }).then((res) => {
        that.showEdit = false;
        that.getList(
          that.selectOneStaff,
          1,
          that.$tableSetting.perPageSize,
          () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          }
        );

        that.$showMessage({
          type: "success",
          text: that.$t("message_essweb_Payslip_form_editSuccessLabel"),
        });
      });
    },
    toDelete(obj) {
      const that = this;
      let uuids = null;
      // 批量下载
      if (
        Object.prototype.toString.call(obj).toLowerCase() === "[object array]"
      ) {
        let arr = [];
        obj.map((item) => {
          arr.push(item.uuid);
        });
        uuids = arr.join(",");
      } else {
        //单个下载
        uuids = obj;
      }
      this.$Request({
        method: "POST",
        table: "x",
        url: "/pay-slip/deletes/",
        data: {
          uuids: uuids,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t("message_essweb_Payslip_form_deleteSuccessLabel"),
        });
        that.selected = [];
        if (
          Object.prototype.toString.call(obj).toLowerCase() === "[object array]"
        ) {
          that.desserts = that.desserts.filter(
            (ele) => uuids.indexOf(ele.uuid) == -1
          );
        } else {
          that.desserts = that.desserts.filter((ele) => uuids !== ele.uuid);
        }
      });
    },
    toEdit(item) {
      this.selected = [];
      this.propertyData = JSON.parse(JSON.stringify(item));
      this.showEdit = true;
    },
    onSubmit(obj) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "x",
        url: "/pay-slip/adds/",
        data: {
          staff_uuid: obj.staff,
          uuids: obj.fileUuids.join(","),
          release_utc_datetime: this.$getTimeValue(obj.date),
        },
      }).then((res) => {
        that.showUpload = false;
        if (Number(that.selectOneStaff) == Number(obj.staff)) {
          that.getList(
            that.selectOneStaff,
            1,
            that.$tableSetting.perPageSize,
            () => {
              that.$store.dispatch("resetTable", new Date().getTime());
            }
          );
        }
        that.$showMessage({
          type: "success",
          text: that.$t("message_essweb_Payslip_form_updateSuccessLabel"),
        });
      });
    },
    toDownLoad(obj) {
      const that = this;
      let uuids = null;
      // 批量下载
      if (
        Object.prototype.toString.call(obj).toLowerCase() === "[object array]"
      ) {
        let arr = [];
        obj.map((item) => {
          arr.push(item.uuid);
        });
        uuids = arr.join(",");
      } else {
        //单个下载
        uuids = obj;
      }
      this.$Request({
        method: "POST",
        table: "x",
        url: "/pay-slip/get-details/",
        data: {
          uuids: uuids,
        },
      }).then((res) => {
        if (res.data.length == 1) {
          if (res.data[0].attachments && res.data[0].attachments.length) {
            // window.open(
            //   item.attachments[0]["url"],
            //   item.attachments[0]["file_name"]
            // );
            FileSaver.saveAs(
              res.data[0].attachments[0]["url"],
              res.data[0].attachments[0]["file_name"]
            );
          } else {
            console.log("没有文件");
          }
        } else {
          that.filesToZip(
            res.data,
            that.$t("label_essweb_admin_Payslip_list_title") +
              "_" +
              dayjs(new Date()).format("YYYYMMDDHHmmss")
          );
        }
      });
    },
    filesToZip(files, filename) {
      let _this = this;
      let zip = new JSZip();
      let cache = {};
      let i = 0;
      let promises = [];
      files.forEach((item) => {
        if (item.attachments && item.attachments.length) {
          var promise = _this
            .getFileBuffer(item.attachments[0]["url"])
            .then((data) => {
              i++;
              let name = i + "_" + item.attachments[0]["file_name"];
              // 下载文件, 并存成ArrayBuffer对象(blob)
              zip.file(name, data, { binary: true }); // 逐个添加文件
              cache[name] = data;
            });
          promises.push(promise);
        }
      });
      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
            // 生成二进制流
            FileSaver.saveAs(content, filename); // 利用file-saver保存文件  自定义文件名
          });
        })
        .catch((res) => {
          console.log("压缩失败");
        });
    },
    getFileBuffer(url) {
      return new Promise((resolve, reject) => {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },
    onSelect(object) {
      this.selected = object;
    },
    fileDragover: function (e) {
      e.preventDefault();
    },
    fileDrop(e) {
      e.preventDefault();

      // if (e.dataTransfer.files.length > 1) {
      //   this.$showMessage({
      //     type: "error",
      //     color: "error",
      //     text: this.$t("message_essweb_update_components_onlyUpdateOneLabel"),
      //   });
      //   return false;
      // }
      this.selectWillStaff = this.selectOneStaff;
      let arr = [];
      for (let index = 0; index < e.dataTransfer.files.length; index++) {
        arr.push(e.dataTransfer.files[index]);
      }

      this.files = arr;
      this.showUpload = true;
    },
    getList(staff, page, perpage, callback) {
      const that = this;
      if (!staff) return;
      this.$Request({
        method: "POST",
        table: "x",
        url: "/pay-slip/get-list/",
        data: {
          staff_uuid: staff,
          cpage: page,
          pagesize: perpage,
        },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage) : null;
      });
    },
  },
};
</script>